import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import PlayCircleOutline from 'material-ui-icons/PlayCircleOutline';

import './Notification.css';

class NotificationBar extends Component  {
    state = {
        isDisplay: true
    }

    closeHandler = () => {
        this.setState({ isDisplay: false })
    }

    render() {
        return (
            <div className="notification__bar" style={{display: this.state.isDisplay? 'flex' : 'none'}}>
                <a className="notification__bar--link"
                   rel="noopener noreferrer"
                   tabIndex='0'
                   target="_blank"
                   href="https://prcsupport.freshdesk.com/a/solutions/articles/24000023273">
                    <PlayCircleOutline />
                    <h2>Quickly learn about the PRC student site!</h2>
                </a>

                <IconButton
                    disableRipple
                    tabIndex='0'
                    aria-label="Close Notification"
                    onClick={()=> this.closeHandler()}
                    className="notification__bar--closeIcon">
                    <CloseIcon />
                </IconButton>
            </div>
        );
    }
}

export default NotificationBar;
